import { createContext } from 'react';

export type PopupExtendedContextType = {
    data: Record<string, NonNullable<unknown> | undefined>;
    setData: (type: string, data: Record<string, NonNullable<unknown> | undefined>) => void;
};

export const PopupExtendedContext = createContext<PopupExtendedContextType>({ data: {}, setData: () => {} });
